<script setup lang="ts">
import { useStatusStore } from '@/stores/statuses'
import { useDate } from 'vuetify'
import {
  VAvatar,
  VImg,
  VCard,
  VCardText,
  VCardSubtitle,
  VDivider,
  VProgressCircular,
} from 'vuetify/components'

const props = defineProps({
  server: String,
  toot: String,
})

const statuses = useStatusStore()
const status = await statuses.lookup(props.server as string, props.toot as string)
const date: any = useDate()
</script>

<template>
  <div v-if="!status">
    <v-progress-circular indeterminate size="96"> Loading </v-progress-circular>
  </div>
  <div v-else>
    <div v-if="status.account.id === status.inReplyToAccountId">
      <v-card class="mx-auto">
        <template v-slot:append>
          {{ date.parseISO(status.createdAt as string).fromNow() }}
        </template>
        <v-card-text>
          <div v-html="status.content" />
          <v-img
            v-if="status.mediaAttachments.length"
            :src="status.mediaAttachments[0].previewUrl"
            width="300"
          >
          </v-img>
        </v-card-text>
        <v-divider />
        <div v-for="child in status.children" :key="child">
          <Post :server="props.server" :toot="child" :parentID="props.toot" />
        </div>
      </v-card>
    </div>
    <div v-else>
      <v-card :title="status.account.displayName" class="mx-auto">
        <v-card-subtitle>
          <a :href="status.account.uri">@{{ status.account.acct }}</a>
        </v-card-subtitle>
        <template v-slot:prepend>
          <v-avatar size="24">
            <v-img :src="status.account.avatar" max-width="24px" max-height="24px" />
          </v-avatar>
        </template>
        <template v-slot:append> {{ date.parseISO(status.createdAt).fromNow() }} </template>
        <v-card-text>
          <div v-html="status.content" />
          <v-img
            v-if="status.mediaAttachments.length"
            :src="status.mediaAttachments[0].previewUrl"
            width="300"
          >
          </v-img>
        </v-card-text>
        <v-divider />
        <div class="comment" v-for="child in status.children" :key="child">
          <Post :server="props.server" :toot="child" :parentID="props.toot" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<style lang="scss">
.comment {
  padding-left: 10px;
  padding-top: 5px;
  margin-left: 5px;
}
</style>
